import {
  ICareTeamRole,
  FETCH_APP_USER_CARE_TEAM,
  FETCH_APP_USER_CARE_TEAM_SUCCESS,
  FETCH_APP_USER_CARE_TEAM_FAILED,
  FETCH_APP_USER_PATHWAY_CARE_TEAM,
  FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS,
  FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED,
  CREATE_CARE_TEAM_ROLE,
  CREATE_CARE_TEAM_ROLE_SUCCESS,
  CREATE_CARE_TEAM_ROLE_FAILED,
  CREATE_CARE_TEAM_ROLE_MEMBER,
  CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  CREATE_CARE_TEAM_ROLE_MEMBER_FAILED,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED,
  EDIT_CARE_TEAM_ROLE_MEMBER,
  EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  EDIT_CARE_TEAM_ROLE_MEMBER_FAILED,
  DELETE_CARE_TEAM_ROLE,
  DELETE_CARE_TEAM_ROLE_SUCCESS,
  DELETE_CARE_TEAM_ROLE_FAILED,
  DELETE_CARE_TEAM_ROLE_MEMBER,
  DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  DELETE_CARE_TEAM_ROLE_MEMBER_FAILED,
  ICareTeamMember,
} from './types';
import { IReduxAction } from '../types';

export interface IFetchAppUserCareTeam
  extends IReduxAction<typeof FETCH_APP_USER_CARE_TEAM, { appUserId: string }> {}
export const fetchAppUserCareTeam = (appUserId: string): IFetchAppUserCareTeam => ({
  type: FETCH_APP_USER_CARE_TEAM,
  payload: { appUserId },
});

export interface IFetchAppUserCareTeamSuccess
  extends IReduxAction<
    typeof FETCH_APP_USER_CARE_TEAM_SUCCESS,
    { appUserId: string; appUserRoles: ICareTeamRole[] }
  > {}
export const fetchAppUserCareTeamSuccess = (
  appUserId: string,
  appUserRoles: ICareTeamRole[],
): IFetchAppUserCareTeamSuccess => ({
  type: FETCH_APP_USER_CARE_TEAM_SUCCESS,
  payload: { appUserId, appUserRoles },
});

export interface IFetchAppUserCareTeamFailed
  extends IReduxAction<typeof FETCH_APP_USER_CARE_TEAM_FAILED> {}
export const fetchAppUserCareTeamFailed = (): IFetchAppUserCareTeamFailed => ({
  type: FETCH_APP_USER_CARE_TEAM_FAILED,
  payload: {},
});

export interface IFetchAppUserPathwayCareTeam
  extends IReduxAction<
    typeof FETCH_APP_USER_PATHWAY_CARE_TEAM,
    { appUserId: string; appUserPathwayId: string }
  > {}
export const fetchAppUserPathwayCareTeam = (
  appUserId: string,
  appUserPathwayId: string,
): IFetchAppUserPathwayCareTeam => ({
  type: FETCH_APP_USER_PATHWAY_CARE_TEAM,
  payload: { appUserId, appUserPathwayId },
});

export interface IFetchAppUserPathwayCareTeamSuccess
  extends IReduxAction<
    typeof FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS,
    { appUserId: string; appUserPathwayId: string; appUserPathwayRoles: ICareTeamRole[] }
  > {}
export const fetchAppUserPathwayCareTeamSuccess = (
  appUserId: string,
  appUserPathwayId: string,
  appUserPathwayRoles: ICareTeamRole[],
): IFetchAppUserPathwayCareTeamSuccess => ({
  type: FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS,
  payload: { appUserId, appUserPathwayId, appUserPathwayRoles },
});

export interface IFetchAppUserPathwayCareTeamFailed
  extends IReduxAction<typeof FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED> {}
export const fetchAppUserPathwayCareTeamFailed = (): IFetchAppUserPathwayCareTeamFailed => ({
  type: FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED,
  payload: {},
});

export interface ICreateCareTeamRole
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE,
    { appUserId: string; name: string; description?: string }
  > {}
export const createCareTeamRole = (
  appUserId: string,
  name: string,
  description?: string,
): ICreateCareTeamRole => ({
  type: CREATE_CARE_TEAM_ROLE,
  payload: { appUserId, name, description },
});

export interface ICreateCareTeamRoleSuccess
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE_SUCCESS,
    { appUserId: string; role: ICareTeamRole }
  > {}
export const createCareTeamRoleSuccess = (
  appUserId: string,
  role: ICareTeamRole,
): ICreateCareTeamRoleSuccess => ({
  type: CREATE_CARE_TEAM_ROLE_SUCCESS,
  payload: { appUserId, role },
});

export interface ICreateCareTeamRoleFailed
  extends IReduxAction<typeof CREATE_CARE_TEAM_ROLE_FAILED> {}
export const createCareTeamRoleFailed = (): ICreateCareTeamRoleFailed => ({
  type: CREATE_CARE_TEAM_ROLE_FAILED,
  payload: {},
});

export interface ICreateCareTeamRoleMember
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE_MEMBER,
    { appUserId: string; roleId: number; member: ICareTeamMember; appUserPathwayId?: string }
  > {}
export const createCareTeamRoleMember = (
  appUserId: string,
  roleId: number,
  member: ICareTeamMember,
  appUserPathwayId?: string,
): ICreateCareTeamRoleMember => ({
  type: CREATE_CARE_TEAM_ROLE_MEMBER,
  payload: { appUserId, roleId, member, appUserPathwayId },
});

export interface ICreateCareTeamRoleMemberSuccess
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
    { appUserId: string; roleId: number; member: ICareTeamMember; appUserPathwayId?: string }
  > {}
export const createCareTeamRoleMemberSuccess = (
  appUserId: string,
  roleId: number,
  member: ICareTeamMember,
  appUserPathwayId?: string,
): ICreateCareTeamRoleMemberSuccess => ({
  type: CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  payload: { appUserId, roleId, member, appUserPathwayId },
});

export interface ICreateCareTeamRoleMemberFailed
  extends IReduxAction<typeof CREATE_CARE_TEAM_ROLE_MEMBER_FAILED> {}
export const createCareTeamRoleMemberFailed = (): ICreateCareTeamRoleMemberFailed => ({
  type: CREATE_CARE_TEAM_ROLE_MEMBER_FAILED,
  payload: {},
});

export interface ICreateCareTeamRoleAndMember
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE_AND_MEMBER,
    { appUserId: string; roleWithMember: ICareTeamRole }
  > {}
export const createCareTeamRoleAndMember = (
  appUserId: string,
  roleWithMember: ICareTeamRole,
): ICreateCareTeamRoleAndMember => ({
  type: CREATE_CARE_TEAM_ROLE_AND_MEMBER,
  payload: { appUserId, roleWithMember },
});

export interface ICreateCareTeamRoleAndMemberSuccess
  extends IReduxAction<
    typeof CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS,
    { appUserId: string; roleWithMember: ICareTeamRole }
  > {}
export const createCareTeamRoleAndMemberSuccess = (
  appUserId: string,
  roleWithMember: ICareTeamRole,
): ICreateCareTeamRoleAndMemberSuccess => ({
  type: CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS,
  payload: { appUserId, roleWithMember },
});

export interface ICreateCareTeamRoleAndMemberFailed
  extends IReduxAction<typeof CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED> {}
export const createCareTeamRoleAndMemberFailed = (): ICreateCareTeamRoleAndMemberFailed => ({
  type: CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED,
  payload: {},
});

export interface IEditCareTeamRoleMember
  extends IReduxAction<
    typeof EDIT_CARE_TEAM_ROLE_MEMBER,
    {
      appUserId: string;
      roleId: number;
      careTeamMemberId: number;
      member: ICareTeamMember;
      appUserPathwayId?: string;
    }
  > {}
export const editCareTeamRoleMember = (
  appUserId: string,
  roleId: number,
  careTeamMemberId: number,
  member: ICareTeamMember,
  appUserPathwayId?: string,
): IEditCareTeamRoleMember => ({
  type: EDIT_CARE_TEAM_ROLE_MEMBER,
  payload: { appUserId, roleId, careTeamMemberId, member, appUserPathwayId },
});

export interface IEditCareTeamRoleMemberSuccess
  extends IReduxAction<
    typeof EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS,
    {
      appUserId: string;
      roleId: number;
      careTeamMemberId: number;
      member: ICareTeamMember;
      appUserPathwayId?: string;
    }
  > {}
export const editCareTeamRoleMemberSuccess = (
  appUserId: string,
  roleId: number,
  careTeamMemberId: number,
  member: ICareTeamMember,
  appUserPathwayId?: string,
): IEditCareTeamRoleMemberSuccess => ({
  type: EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  payload: { appUserId, roleId, careTeamMemberId, member, appUserPathwayId },
});

export interface IEditCareTeamRoleMemberFailed
  extends IReduxAction<typeof EDIT_CARE_TEAM_ROLE_MEMBER_FAILED> {}
export const editCareTeamRoleMemberFailed = (): IEditCareTeamRoleMemberFailed => ({
  type: EDIT_CARE_TEAM_ROLE_MEMBER_FAILED,
  payload: {},
});

export interface IDeleteCareTeamRole
  extends IReduxAction<
    typeof DELETE_CARE_TEAM_ROLE,
    { appUserId: string; careTeamRoleId: number }
  > {}
export const deleteCareTeamRole = (
  appUserId: string,
  careTeamRoleId: number,
): IDeleteCareTeamRole => ({
  type: DELETE_CARE_TEAM_ROLE,
  payload: { appUserId, careTeamRoleId },
});

export interface IDeleteCareTeamRoleSuccess
  extends IReduxAction<
    typeof DELETE_CARE_TEAM_ROLE_SUCCESS,
    { appUserId: string; careTeamRoleId: number }
  > {}
export const deleteCareTeamRoleSuccess = (
  appUserId: string,
  careTeamRoleId: number,
): IDeleteCareTeamRoleSuccess => ({
  type: DELETE_CARE_TEAM_ROLE_SUCCESS,
  payload: { appUserId, careTeamRoleId },
});

export interface IDeleteCareTeamRoleFailed
  extends IReduxAction<typeof DELETE_CARE_TEAM_ROLE_FAILED> {}
export const deleteCareTeamRoleFailed = (): IDeleteCareTeamRoleFailed => ({
  type: DELETE_CARE_TEAM_ROLE_FAILED,
  payload: {},
});

export interface IDeleteCareTeamRoleMember
  extends IReduxAction<
    typeof DELETE_CARE_TEAM_ROLE_MEMBER,
    { appUserId: string; roleId: number; careTeamMemberId: number; appUserPathwayId?: string }
  > {}
export const deleteCareTeamRoleMember = (
  appUserId: string,
  roleId: number,
  careTeamMemberId: number,
  appUserPathwayId?: string,
): IDeleteCareTeamRoleMember => ({
  type: DELETE_CARE_TEAM_ROLE_MEMBER,
  payload: { appUserId, roleId, careTeamMemberId, appUserPathwayId },
});

export interface IDeleteCareTeamRoleMemberSuccess
  extends IReduxAction<
    typeof DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
    { appUserId: string; roleId: number; careTeamMemberId: number; appUserPathwayId?: string }
  > {}
export const deleteCareTeamRoleMemberSuccess = (
  appUserId: string,
  roleId: number,
  careTeamMemberId: number,
  appUserPathwayId?: string,
): IDeleteCareTeamRoleMemberSuccess => ({
  type: DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  payload: { appUserId, roleId, careTeamMemberId, appUserPathwayId },
});

export interface IDeleteCareTeamRoleMemberFailed
  extends IReduxAction<typeof DELETE_CARE_TEAM_ROLE_MEMBER_FAILED> {}
export const deleteCareTeamRoleMemberFailed = (): IDeleteCareTeamRoleMemberFailed => ({
  type: DELETE_CARE_TEAM_ROLE_MEMBER_FAILED,
  payload: {},
});
